import {
  Component,
  Injectable,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';

import { FormArray, FormGroup } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';

import { Directive, ViewContainerRef, Type } from '@angular/core';

@Directive({
    selector: '[appFormContainer]',
    standalone: false
})
export class FormContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}

  component: Type<any>;
}

@Injectable({
  providedIn: 'root',
})
export class FormService {
  private formGroupSubject: BehaviorSubject<FormGroup | null> =
    new BehaviorSubject<FormGroup | null>(null);

  setFormGroup(formGroup: FormGroup) {
    this.formGroupSubject.next(formGroup);
  }

  getFormGroup(): BehaviorSubject<FormGroup | null> {
    return this.formGroupSubject;
  }
}

@Component({
    selector: 'form-wizard-owners',
    templateUrl: './form-wizard-owners.component.html',
    styleUrls: ['./form-wizard-owners.component.scss'],
    standalone: false
})
export class FormWizardOwnersComponent implements OnInit {
  receivedFormGroup: FormGroup;

  private formGroupSubscription: Subscription | undefined;
  @Input() template: TemplateRef<any>;

  constructor(private formService: FormService) {}

  ngOnInit() {
    this.formGroupSubscription = this.formService
      .getFormGroup()
      .subscribe(formGroup => {
        this.receivedFormGroup = formGroup;
      });
  }
  ngOnDestroy() {
    if (this.formGroupSubscription) {
      this.formGroupSubscription.unsubscribe();
    }
  }
  get owners() {
    return this.receivedFormGroup.get('owners') as FormArray;
  }
}
